// The store theme's environment (shopify/sections/nothing-cross.liquid): the
// section's settings as the options, the product and the scene's asset URLs
// from Liquid, the theme connector (js/shop/theme-connector.js) and the
// product form the section rendered, and the scene's fetches the section's
// inline script started (window.ncLoad). The standalone site has
// its own, js/site.js. The section runs this module, then js/landing.js, as
// two module scripts (they run in document order). See js/page-env.js and
// docs/shopify.md.
//
// The section renders its configuration as JSON (#nc-config):
//   options    { key: value } for the options the section has settings for
//              (js/options.js); the rest are the registry's defaults
//   product    { title, available, price: { amount, currencyCode }, priceLabel }
//   variantId  the variant the form buys
//   drive      { name, capacity, photos }: photos is the URL of the theme's
//              nc-photos.json asset, the drive's manifest (docs/shopify.md)
//   assets     { "cross.glb": url, ... }: every asset the scene loads
//   redesign   { settings, blocks, stylesheets }: the redesigned page's
//              content (page=redesign), the section's settings and blocks
//              (js/redesign/content.js's fromSection puts them in its shape;
//              their defaults are content.js's: npm run shopify), and its
//              stylesheets' asset URLs
import { optionsFromValues } from "./options.js";
import { fromSection } from "./redesign/content.js";
import { setPageEnv } from "./page-env.js";
import { createThemeConnector } from "./shop/theme-connector.js";
import { HEAD_LINES, storeHeaderMode } from "./variants/header.js";

// Horizon 3.x's own cart-changed event, fired when its cart drawer changes a
// quantity (assets/events.js, ThemeEvents.cartUpdate)
const THEME_CART_EVENTS = ["cart:update"];

function readConfig() {
  const el = document.getElementById("nc-config");
  if (!el) throw new Error("theme: the section rendered no #nc-config");
  return JSON.parse(el.textContent);
}

const config = readConfig();
const form = document.getElementById("nc-buy-form");
if (!form) throw new Error("theme: the section rendered no #nc-buy-form");

if (!window.ncLoad) throw new Error("theme: the section started no fetches of the scene's files (window.ncLoad)");

// The store header fades (or comes in late) only where the theme's <head>
// lines hid it from the first paint (js/variants/header.js); without them
// it stays visible. The section's own inline script decided the same.
const headLines = HEAD_LINES in document.documentElement.dataset;

setPageEnv({
  readOptions: () => {
    const options = optionsFromValues(config.options);
    return { ...options, header: storeHeaderMode(options.header, headLines) };
  },
  connector: createThemeConnector({ product: config.product, variantId: config.variantId, themeCartEvents: THEME_CART_EVENTS }),
  buyForm: { form },
  // its photos: the theme's own assets, by their manifest's URL (nc-photos.json)
  drive: config.drive,
  assetUrl: (file) => {
    const url = config.assets[file];
    if (!url) throw new Error(`theme: the section gave no URL for the scene's asset "${file}"`);
    return url;
  },
  responses: window.ncLoad.responses,
  redesign: { sections: fromSection(config.redesign), stylesheets: config.redesign.stylesheets },
});
